<template>
  <b-modal id="createLeaveCycleModal" :title="leaveCycle ? 'Edit Leave Cycle' : 'Create Leave Cycle'" hide-footer no-close-on-backdrop @show="populateForm" @hidden="resetForm">
    <div class="loading" v-if="saving">
      <load-data></load-data>
    </div>

    <b-form v-else @submit.prevent="submit">
      <b-form-group label="Name" label-for="name">
        <b-form-input
          id="name"
          v-model="form.name"
          placeholder="Enter leave cycle name"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Start Date" label-for="start_date">
        <b-form-datepicker id="start_date" v-model="form.start_date" required></b-form-datepicker>
      </b-form-group>

      <b-form-group label="End Date" label-for="end_date">
        <b-form-datepicker id="end_date" v-model="form.end_date" :min="form.start_date" required></b-form-datepicker>
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('createLeaveCycleModal')">Cancel</b-button>
        <b-button type="submit" variant="primary">{{ leaveCycle ? 'Save' : 'Create' }}</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  props: {
    leaveCycle: { type: Object, default: null },
  },

  data() {
    return {
      saving: false,
      form: {
        name: "",
        start_date: "",
        end_date: "",
      },
    };
  },

  methods: {
    async submit() {
      this.saving = true;

      const baseUrl = this.$store.getters.getAPIKey.mainAPI + `/faculty-leave`;
      const request = this.leaveCycle
        ? axios.put(`${baseUrl}/${this.leaveCycle.id}`, this.form)
        : axios.post(baseUrl, this.form);

      await request
        .then(() => {
          this.$toast.success(`Leave cycle ${this.leaveCycle ? 'updated' : 'created'} successfully`, {
            position: "top",
            duration: 3000,
          });
          this.$bvModal.hide("createLeaveCycleModal");
          this.$emit(this.leaveCycle ? "updated" : "created");
        })
        .catch(() => {});

      this.saving = false;
    },

    populateForm() {
      if (this.leaveCycle) {
        this.form = { name: this.leaveCycle.name, start_date: this.leaveCycle.start_date, end_date: this.leaveCycle.end_date };
      }
    },

    resetForm() {
      this.form = { name: "", start_date: "", end_date: "" };
    },
  },
};
</script>
